import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import DelayedSplashScreen from '~/components/views/SplashScreen/DelayedSplashScreen';
import ErrorBoundary from '~/core/components/ErrorBoundary/ErrorBoundary';

const SuspendedRoute: React.FC<RouteProps> = (props) => {
  const { render, ...otherProps } = props;

  return (
    <Route
      {...otherProps}
      render={(e) => {
        return (
          <ErrorBoundary>
            <React.Suspense fallback={<DelayedSplashScreen />}>{render?.(e)}</React.Suspense>
          </ErrorBoundary>
        );
      }}
    />
  );
};

export default SuspendedRoute;
